export const ACTIONS = {
  RECORD_ENABLE_GROUP_CHAT: 'RECORD_ENABLE_GROUP_CHAT',
};

export const recordEnableGroupChat = data => dispatch => {
  dispatch({
    type: ACTIONS.RECORD_ENABLE_GROUP_CHAT,
    payload: data,
  });
};
